import React from "react";
import { Modal } from "react-bootstrap";

const ModelLoader = ({ show, setShow, title = "Loading..." }) => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            centered
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-transparent"
        >
            <Modal.Body className="d-flex flex-column align-items-center justify-content-center text-center py-5">
                <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-dark fs-5 fw-medium">{title}</p>
            </Modal.Body>
        </Modal>
    );
};

export default ModelLoader;
